export const DefaultLoader = ({ size }: { size?: 'default' | 'icon' }) => {
  const loaderSize = size === 'icon' ? 'w-4 h-4' : 'w-5 h-5'
  return (
    <svg
      className={`animate-spin ${loaderSize} text-white`}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 000 16v-4l-3 3 3 3v-4a8 8 0 01-8-8z"
      />
    </svg>
  )
}
